import { Spin } from 'antd';
import { createBrowserRouter, Navigate, type IndexRouteObject } from 'react-router-dom';
import { AnalyticsRouteBoundary } from './AnalyticsRouteBoundary';

/**
 * 路由切换时的加载状态
 */
const hydrateFallbackElement = (
  <Spin
    size="large"
    fullscreen
    spinning
  />
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AnalyticsRouteBoundary />,
    children: [
      {
        index: true,
        lazy: lazyPage(() => import('../pages/home/Home')),
        hydrateFallbackElement,
      },
      {
        path: 'model_3d',
        lazy: lazyPage(() => import('../pages/model_3d/Model3D')),
        hydrateFallbackElement,
      },
      {
        path: 'about_us',
        lazy: lazyPage(() => import('../pages/about_us/AboutUs')),
        hydrateFallbackElement,
      },
      {
        path: '*',
        element: (
          <Navigate
            to="/"
            replace
          />
        ),
      },
    ],
  },
]);

/**
 * 动态导入加载器
 * @param importPath - 页面导入
 * @returns 加载器
 */
function lazyPage(
  importPath: () => Promise<{ default: React.ComponentType }>,
  options?: Partial<Omit<IndexRouteObject['lazy'], 'Component'>>,
): IndexRouteObject['lazy'] {
  return async () => ({
    Component: (await importPath()).default,
    ...options,
  });
}
